/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from './index-892d8eee.js';

var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};

var _excluded = ["_ext"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends$6({}, rest, _ext[baseName] || {});
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

/**
 * merge default options
 * @param containerName
 * @param options
 */
function getMergedOptions(containerName, options) {
  var mergedOptions = styleIn(_extends$5({
    duration: 400,
    timingFunction: 'linear',
    delay: 0,
    transformOrigin: '50% 50% 0'
  }, options), containerName); // set the min duration to 16ms to avoid some problems

  if (mergedOptions.duration < 16) {
    mergedOptions.duration = 16;
  }

  return mergedOptions;
}
/**
 * parse value of transform
 * @param value
 */

function parseTransform(value) {
  value = String(value || '');
  var pos = 0;

  var isValidWord = function isValidWord(code) {
    if (code >= 65 && code <= 90) return true; // A-Z

    if (code >= 97 && code <= 122) return true; // a-z

    if (code >= 48 && code <= 57) return true; // 0-9

    if (code === 45 || code === 46) return true; // `-` or `.`

    return false;
  };

  var skipSpace = function skipSpace() {
    while (pos < value.length) {
      var code = value.charCodeAt(pos);

      if (code === 32 || code === 160) {
        // ` `
        pos++;
      } else if (code === 13 || code === 10 || code === 8232 || code === 8233) {
        // new line
        if (code === 13 && value.charCodeAt(pos + 1) === 10) {
          // CRLF
          pos++;
        }

        pos++;
      } else if (code > 8 && code < 14) {
        // other space
        pos++;
      } else {
        break;
      }
    }
  };

  var eat = function eat(_char) {
    if (value[pos] === _char) {
      pos++;
      return true;
    }

    return false;
  };

  var parseAtom = function parseAtom() {
    var name = '';
    var args = [];
    var isReadArgs = false;
    var isExpectWord = true;

    while (pos < value.length) {
      skipSpace();
      var code = value.charCodeAt(pos);

      if (isExpectWord) {
        if (!isValidWord(code)) break;
        var chunkStart = pos;

        while (pos < value.length && isValidWord(code)) {
          code = value.charCodeAt(++pos);
        }

        var str = value.slice(chunkStart, pos);

        if (isReadArgs) {
          args.push(str);
          isExpectWord = false;
        } else {
          name = str;
          skipSpace();
          if (!eat('(')) break;
          isReadArgs = true;
          isExpectWord = true;
        }
      } else if (code === 44) {
        // `,`
        isExpectWord = true;
        pos++;
      } else {
        break;
      }
    }

    if (isExpectWord || !eat(')')) return null;
    if (!name || args.length === 0) return null;
    return {
      name: name,
      args: args
    };
  };

  var hasInvalid = false;

  var getValidArg = function getValidArg(val, unit) {
    if (unit === void 0) {
      unit = '';
    }

    var match = new RegExp("^(-?\\d*(\\.\\d+)?)" + unit + "$", 'i').exec(val);

    if (match && match[1]) {
      return Number(match[1]);
    } else {
      hasInvalid = true;
    }
  };

  var result = {};

  while (pos < value.length) {
    var res = parseAtom();
    skipSpace();
    if (!res) return {};
    var args = res.args;

    if (['rotate', 'rotateX', 'rotateY', 'rotateZ', 'skew', 'skewX', 'skewY'].includes(res.name)) {
      args = args.map(function (arg) {
        return getValidArg(arg, 'deg');
      });
    } else if (['translate', 'translateX', 'translateY', 'translateZ', 'translate3d'].includes(res.name)) {
      args = args.map(function (arg) {
        return getValidArg(arg, 'px');
      });
    } else if (['scale', 'scale3d', 'scaleX', 'scaleY', 'scaleZ', 'matrix', 'matrix3d'].includes(res.name)) {
      args = args.map(function (arg) {
        return getValidArg(arg, '');
      });
    } else if (res.name === 'rotate3d') {
      args = [].concat(args.slice(0, 3).map(function (arg) {
        return getValidArg(arg, '');
      }), args.slice(3, 4).map(function (arg) {
        return getValidArg(arg, 'deg');
      }));
    } else {
      return {};
    }

    if (hasInvalid) return {};
    result[res.name] = args;
  }

  return result;
}
/**
 * normalize createTransition method
 * @param animation
 * @param options
 */

function normalizeCreateTransition(animation, options) {
  var _ref = options || {},
      _ref$from = _ref.from,
      from = _ref$from === void 0 ? {} : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === void 0 ? {} : _ref$to,
      animationOptions = _ref.options;

  var applyTransform = function applyTransform(opts) {
    Object.keys(opts).forEach(function (key) {
      var value = opts[key];

      if (key === 'transform') {
        applyTransform(parseTransform(value));
      } else if (typeof animation[key] === 'function') {
        if (Array.isArray(value)) {
          animation[key].apply(animation, value);
        } else {
          animation[key](value);
        }
      }
    });
  }; // from


  applyTransform(from);
  animation.step(_extends$5({}, animationOptions, {
    duration: 16,
    delay: 0
  })); // to

  applyTransform(to);
  animation.step(animationOptions);
  return animation;
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function createAnimation$5(options) {
  var animation = my.createAnimation(getMergedOptions(CONTAINER_NAME.ALIPAY, options)); // override

  var _step = animation.step.bind(animation);

  var _export = animation.export.bind(animation);

  animation.step = function (opts) {
    opts = getMergedOptions(CONTAINER_NAME.ALIPAY, _extends$4({}, options, opts));
    return _step(opts);
  };

  animation.export = function () {
    return _export();
  };

  return animation;
}

function createTransition$5(options) {
  var animation = createAnimation$5();
  return normalizeCreateTransition(animation, options);
}

var aliMiniAppModule = {
  createAnimation: createAnimation$5,
  createTransition: createTransition$5
};

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var ANIMATION_RUNNING = '__UNI_API_ANIMATION_RUNNING__';
var ANIMATION_CANCEL = '__UNI_API_ANIMATION_CANCEL__';
var ANIMATION_ORIGINAL_STYLE = '__UNI_API_ANIMATION_ORIGINAL_STYLE__';
/**
 * normalize unit
 * @param value
 * @param unit
 * @param force
 */

function normalizeUnit(value, unit, force) {
  if (force === void 0) {
    force = false;
  }

  if (force || typeof value === 'number') {
    return "" + value + unit;
  }

  return value;
}
/**
 * handle animation actions queue
 * @param actions
 * @param fn
 * @param onFinish
 */


function handleActionsQueue(actions, fn, onFinish) {
  actions = actions.slice();
  var action = actions.shift();

  if (action) {
    fn(action, function () {
      return handleActionsQueue(actions, fn, onFinish);
    });
  } else if (onFinish) {
    onFinish();
  }
}
/**
 * apply animation for web-side
 * @param actions
 * @param dom
 */


function applyWebAnimation(actions, dom) {
  // If `dom` is not HTML Node, ignore
  if (!(dom && dom.nodeType === 1)) {
    return;
  } // clear the last animation


  if (dom[ANIMATION_RUNNING]) {
    (dom[ANIMATION_CANCEL] || []).forEach(function (t) {
      return clearTimeout(t);
    });
  } else {
    // cache original style
    dom[ANIMATION_ORIGINAL_STYLE] = {
      transitionProperty: dom.style.transitionProperty,
      transitionDuration: dom.style.transitionDuration,
      transitionDelay: dom.style.transitionDelay,
      transitionTimingFunction: dom.style.transitionTimingFunction,
      transformOrigin: dom.style.transformOrigin
    };
  }

  dom[ANIMATION_RUNNING] = true;
  dom[ANIMATION_CANCEL] = [];
  /**
   * Apply animation action, return the current cost time
   * @param action
   */

  var applyAction = function applyAction(action) {
    var _action$option = action.option,
        transition = _action$option.transition,
        transformOrigin = _action$option.transformOrigin;
    var transform = [];
    action.animates.forEach(function (animate) {
      if (animate.type === 'style') {
        var _animate$args = animate.args,
            property = _animate$args[0],
            value = _animate$args[1];
        dom.style[property] = value;
      } else {
        transform.push(animate.type + "(" + animate.args.join(',') + ")");
      }
    });

    if (transform.length > 0) {
      dom.style.transform = transform.join(' ');
    }

    dom.style.transitionProperty = 'all';
    dom.style.transitionDuration = transition.duration + "ms";
    dom.style.transitionDelay = transition.delay + "ms";
    dom.style.transitionTimingFunction = transition.timingFunction;
    dom.style.transformOrigin = transformOrigin;
    var cost = transition.delay + transition.duration;
    return isNaN(cost) ? 0 : cost;
  };

  var saveCancel = function saveCancel(timer) {
    dom[ANIMATION_CANCEL] = dom[ANIMATION_CANCEL] || [];
    dom[ANIMATION_CANCEL].push(timer);
  };

  var delay = 0;
  handleActionsQueue(actions, function (action, callback) {
    saveCancel(setTimeout(function () {
      delay = applyAction(action);
      callback();
    }, delay));
  }, function () {
    saveCancel( // Restore the style at the end of the animation
    setTimeout(function () {
      Object.assign(dom.style, dom[ANIMATION_ORIGINAL_STYLE] || {});
      dom[ANIMATION_RUNNING] = null;
      dom[ANIMATION_CANCEL] = null;
      dom[ANIMATION_ORIGINAL_STYLE] = null;
    }, delay));
  });
}

var AnimationImpl = /*#__PURE__*/function () {
  function AnimationImpl(options) {
    this.options = void 0;
    this.actions = void 0;
    this.currentTransform = void 0;
    this.currentStepAnimates = void 0;
    this.options = getMergedOptions(CONTAINER_NAME.WEB, options);
    this.actions = [];
    this.currentTransform = {};
    this.currentStepAnimates = [];
  }

  var _proto = AnimationImpl.prototype;

  _proto.export = function _export(dom) {
    var actions = this.actions.slice();
    applyWebAnimation(actions, dom);
    this.actions = [];
    return {
      actions: actions
    };
  };

  _proto.step = function step(options) {
    var _this = this;

    options = getMergedOptions(CONTAINER_NAME.WEB, _extends$3({}, this.options, options));
    this.currentStepAnimates.forEach(function (animate) {
      var key = animate.type;

      if (key === 'style') {
        key += "." + animate.args[0];
      }

      _this.currentTransform[key] = animate;
    });
    var animates = [];
    Object.keys(this.currentTransform).forEach(function (key) {
      animates.push(_this.currentTransform[key]);
    });
    this.actions.push({
      animates: animates,
      option: {
        transformOrigin: options.transformOrigin,
        transition: {
          delay: options.delay,
          duration: options.duration,
          timingFunction: options.timingFunction
        }
      }
    });
    this.currentStepAnimates = [];
    return this;
  };

  _proto.opacity = function opacity(value) {
    this.currentStepAnimates.push({
      type: 'style',
      args: ['opacity', value]
    });
    return this;
  };

  _proto.backgroundColor = function backgroundColor(value) {
    this.currentStepAnimates.push({
      type: 'style',
      args: ['background-color', value]
    });
    return this;
  };

  _proto.width = function width(value) {
    this.currentStepAnimates.push({
      type: 'style',
      args: ['width', normalizeUnit(value, 'px')]
    });
    return this;
  };

  _proto.height = function height(value) {
    this.currentStepAnimates.push({
      type: 'style',
      args: ['height', normalizeUnit(value, 'px')]
    });
    return this;
  };

  _proto.left = function left(value) {
    this.currentStepAnimates.push({
      type: 'style',
      args: ['left', normalizeUnit(value, 'px')]
    });
    return this;
  };

  _proto.right = function right(value) {
    this.currentStepAnimates.push({
      type: 'style',
      args: ['right', normalizeUnit(value, 'px')]
    });
    return this;
  };

  _proto.top = function top(value) {
    this.currentStepAnimates.push({
      type: 'style',
      args: ['top', normalizeUnit(value, 'px')]
    });
    return this;
  };

  _proto.bottom = function bottom(value) {
    this.currentStepAnimates.push({
      type: 'style',
      args: ['bottom', normalizeUnit(value, 'px')]
    });
    return this;
  };

  _proto.rotate = function rotate(angle) {
    if (angle === void 0) {
      angle = 0;
    }

    this.currentStepAnimates.push({
      type: 'rotate',
      args: [normalizeUnit(angle, 'deg', true)]
    });
    return this;
  };

  _proto.rotate3d = function rotate3d(x, y, z, angle) {
    if (x === void 0) {
      x = 0;
    }

    if (y === void 0) {
      y = 0;
    }

    if (z === void 0) {
      z = 0;
    }

    if (angle === void 0) {
      angle = 0;
    }

    this.currentStepAnimates.push({
      type: 'rotate3d',
      args: [x, y, z, normalizeUnit(angle, 'deg', true)]
    });
    return this;
  };

  _proto.rotateX = function rotateX(angle) {
    if (angle === void 0) {
      angle = 0;
    }

    this.currentStepAnimates.push({
      type: 'rotateX',
      args: [normalizeUnit(angle, 'deg', true)]
    });
    return this;
  };

  _proto.rotateY = function rotateY(angle) {
    if (angle === void 0) {
      angle = 0;
    }

    this.currentStepAnimates.push({
      type: 'rotateY',
      args: [normalizeUnit(angle, 'deg', true)]
    });
    return this;
  };

  _proto.rotateZ = function rotateZ(angle) {
    if (angle === void 0) {
      angle = 0;
    }

    this.currentStepAnimates.push({
      type: 'rotateZ',
      args: [normalizeUnit(angle, 'deg', true)]
    });
    return this;
  };

  _proto.scale = function scale(sx, sy) {
    if (sx === undefined) sx = 1;
    if (sy === undefined) sy = sx;
    this.currentStepAnimates.push({
      type: 'scale',
      args: [sx, sy]
    });
    return this;
  };

  _proto.scale3d = function scale3d(sx, sy, sz) {
    if (sx === void 0) {
      sx = 1;
    }

    if (sy === void 0) {
      sy = 1;
    }

    if (sz === void 0) {
      sz = 1;
    }

    this.currentStepAnimates.push({
      type: 'scale3d',
      args: [sx, sy, sz]
    });
    return this;
  };

  _proto.scaleX = function scaleX(scale) {
    if (scale === void 0) {
      scale = 1;
    }

    this.currentStepAnimates.push({
      type: 'scaleX',
      args: [scale]
    });
    return this;
  };

  _proto.scaleY = function scaleY(scale) {
    if (scale === void 0) {
      scale = 1;
    }

    this.currentStepAnimates.push({
      type: 'scaleY',
      args: [scale]
    });
    return this;
  };

  _proto.scaleZ = function scaleZ(scale) {
    if (scale === void 0) {
      scale = 1;
    }

    this.currentStepAnimates.push({
      type: 'scaleZ',
      args: [scale]
    });
    return this;
  };

  _proto.translate = function translate(tx, ty) {
    if (tx === void 0) {
      tx = 0;
    }

    if (ty === void 0) {
      ty = 0;
    }

    this.currentStepAnimates.push({
      type: 'translate',
      args: [normalizeUnit(tx, 'px', true), normalizeUnit(ty, 'px', true)]
    });
    return this;
  };

  _proto.translate3d = function translate3d(tx, ty, tz) {
    if (tx === void 0) {
      tx = 0;
    }

    if (ty === void 0) {
      ty = 0;
    }

    if (tz === void 0) {
      tz = 0;
    }

    this.currentStepAnimates.push({
      type: 'translate3d',
      args: [normalizeUnit(tx, 'px', true), normalizeUnit(ty, 'px', true), normalizeUnit(tz, 'px', true)]
    });
    return this;
  };

  _proto.translateX = function translateX(translation) {
    if (translation === void 0) {
      translation = 0;
    }

    this.currentStepAnimates.push({
      type: 'translateX',
      args: [normalizeUnit(translation, 'px', true)]
    });
    return this;
  };

  _proto.translateY = function translateY(translation) {
    if (translation === void 0) {
      translation = 0;
    }

    this.currentStepAnimates.push({
      type: 'translateY',
      args: [normalizeUnit(translation, 'px', true)]
    });
    return this;
  };

  _proto.translateZ = function translateZ(translation) {
    if (translation === void 0) {
      translation = 0;
    }

    this.currentStepAnimates.push({
      type: 'translateZ',
      args: [normalizeUnit(translation, 'px', true)]
    });
    return this;
  };

  _proto.skew = function skew(ax, ay) {
    if (ax === void 0) {
      ax = 0;
    }

    if (ay === void 0) {
      ay = 0;
    }

    this.currentStepAnimates.push({
      type: 'skew',
      args: [normalizeUnit(ax, 'deg', true), normalizeUnit(ay, 'deg', true)]
    });
    return this;
  };

  _proto.skewX = function skewX(angle) {
    if (angle === void 0) {
      angle = 0;
    }

    this.currentStepAnimates.push({
      type: 'skewX',
      args: [normalizeUnit(angle, 'deg', true)]
    });
    return this;
  };

  _proto.skewY = function skewY(angle) {
    if (angle === void 0) {
      angle = 0;
    }

    this.currentStepAnimates.push({
      type: 'skewY',
      args: [normalizeUnit(angle, 'deg', true)]
    });
    return this;
  };

  _proto.matrix = function matrix(a, b, c, d, tx, ty) {
    if (a === void 0) {
      a = 1;
    }

    if (b === void 0) {
      b = 0;
    }

    if (c === void 0) {
      c = 0;
    }

    if (d === void 0) {
      d = 1;
    }

    if (tx === void 0) {
      tx = 0;
    }

    if (ty === void 0) {
      ty = 0;
    }

    this.currentStepAnimates.push({
      type: 'matrix',
      args: [a, b, c, d, tx, ty]
    });
    return this;
  };

  _proto.matrix3d = function matrix3d(a1, b1, c1, d1, a2, b2, c2, d2, a3, b3, c3, d3, a4, b4, c4, d4) {
    if (a1 === void 0) {
      a1 = 1;
    }

    if (b1 === void 0) {
      b1 = 0;
    }

    if (c1 === void 0) {
      c1 = 0;
    }

    if (d1 === void 0) {
      d1 = 0;
    }

    if (a2 === void 0) {
      a2 = 0;
    }

    if (b2 === void 0) {
      b2 = 1;
    }

    if (c2 === void 0) {
      c2 = 0;
    }

    if (d2 === void 0) {
      d2 = 0;
    }

    if (a3 === void 0) {
      a3 = 0;
    }

    if (b3 === void 0) {
      b3 = 0;
    }

    if (c3 === void 0) {
      c3 = 1;
    }

    if (d3 === void 0) {
      d3 = 0;
    }

    if (a4 === void 0) {
      a4 = 0;
    }

    if (b4 === void 0) {
      b4 = 0;
    }

    if (c4 === void 0) {
      c4 = 0;
    }

    if (d4 === void 0) {
      d4 = 1;
    }

    this.currentStepAnimates.push({
      type: 'matrix3d',
      args: [a1, b1, c1, d1, a2, b2, c2, d2, a3, b3, c3, d3, a4, b4, c4, d4]
    });
    return this;
  };

  return AnimationImpl;
}();

function createAnimation$4(options) {
  return new AnimationImpl(options);
}

function createTransition$4(options) {
  var animation = createAnimation$4();
  return normalizeCreateTransition(animation, options);
}

var webModule = {
  createAnimation: createAnimation$4,
  createTransition: createTransition$4
};

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function createAnimation$3(options) {
  var animation = wx.createAnimation(getMergedOptions(CONTAINER_NAME.WECHAT, options)); // override

  var _step = animation.step.bind(animation);

  var _export = animation.export.bind(animation);

  animation.step = function (opts) {
    opts = getMergedOptions(CONTAINER_NAME.WECHAT, _extends$2({}, options, opts));
    return _step(opts);
  };

  animation.export = function () {
    return _export();
  };

  return animation;
}

function createTransition$3(options) {
  var animation = createAnimation$3();
  return normalizeCreateTransition(animation, options);
}

var weChatModule = {
  createAnimation: createAnimation$3,
  createTransition: createTransition$3
};

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function createAnimation$2(options) {
  var animation = tt.createAnimation(getMergedOptions(CONTAINER_NAME.BYTE, options)); // override

  var _step = animation.step.bind(animation);

  var _export = animation.export.bind(animation);

  animation.step = function (opts) {
    opts = getMergedOptions(CONTAINER_NAME.BYTE, _extends$1({}, options, opts));
    return _step(opts);
  };

  animation.export = function () {
    return _export();
  };

  return animation;
}

function createTransition$2(options) {
  var animation = createAnimation$2();
  return normalizeCreateTransition(animation, options);
}

var bytedanceModule = {
  createAnimation: createAnimation$2,
  createTransition: createTransition$2
};

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function createAnimation$1(options) {
  var animation = swan.createAnimation(getMergedOptions(CONTAINER_NAME.BAIDU, options)); // override

  var _step = animation.step.bind(animation);

  var _export = animation.export.bind(animation);

  animation.step = function (opts) {
    opts = getMergedOptions(CONTAINER_NAME.BAIDU, _extends({}, options, opts));
    return _step(opts);
  };

  animation.export = function () {
    return _export();
  };

  return animation;
}

function createTransition$1(options) {
  var animation = createAnimation$1();
  return normalizeCreateTransition(animation, options);
}

var baiDuModule = {
  createAnimation: createAnimation$1,
  createTransition: createTransition$1
};

function createAnimation(options) {
  if (isWeb) {
    return webModule.createAnimation(options);
  } else if (isKuaiShouMiniProgram) {
    throw new Error('@uni/apis：createAnimation 暂不支持');
  } else if (isWeChatMiniProgram) {
    return weChatModule.createAnimation(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.createAnimation(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.createAnimation(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.createAnimation(options);
  } else {
    throw new Error('@uni/apis：createAnimation 暂不支持');
  }
}
function createTransition(options) {
  if (isWeb) {
    return webModule.createTransition(options);
  } else if (isKuaiShouMiniProgram) {
    throw new Error('@uni/apis：createAnimation 暂不支持');
  } else if (isWeChatMiniProgram) {
    return weChatModule.createTransition(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.createTransition(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.createTransition(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.createTransition(options);
  } else {
    throw new Error('@uni/apis：createTransition 暂不支持');
  }
}

export { createTransition as a, createAnimation as c };
